import React from 'react'
import { Row, Col } from '@themesberg/react-bootstrap'
import { Formik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Buffer } from 'buffer'
import { toast } from '../../../../components/Toast'
import StaffForm from './StaffForm'
import { updateStaffAdminStart } from '../../../../store/redux-slices/staffSlice'
import { HeaderSection, ResponsiveTitle, ButtonContainer } from '../../TransactionsBanking/style'
import NotificationIconContainer from '../../../../components/NotificationIcon/NotificationIconContainer'
import { updateStaffSchema } from '../schema'
import { ROLES } from '../constants'
import { useEditStaff } from '../hooks/useEditStaff'
import { AdminsRoutes } from '../../../../routes'
import PageBackButton from '../../../../components/PageBackButton'

const EditStaff = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { adminDetails: { AdminRole: { name } } } = useSelector(state => state.admins)
  const { staffDetails, loading, getOriginalPhone } = useEditStaff()

  const handleCreateSubmit = (formValues) => {
    if ([undefined, null].includes(formValues.permission) || Object.keys(formValues.permission).length < 1) {
      toast('Please select at least one permission', 'error')
    } else {
      dispatch(updateStaffAdminStart({
        data: {
          adminUserId: staffDetails?.adminUserId,
          adminUsername: formValues.adminUsername,
          password: Buffer.from(formValues.password).toString('base64'),
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          email: formValues.email,
          phone: `${formValues.phoneCode} ${formValues.phone}`,
          isPhoneVerified: formValues.isPhoneVerified,
          userType: name?.toLowerCase(),
          group: formValues.group,
          role: ROLES.find(role => role.roleId === staffDetails?.adminRoleId)?.title,
          permission: formValues.permission
        },
        onSuccess: () => navigate(AdminsRoutes.Staff)
      }))
    }
  }

  return (
    <div>
      <HeaderSection className="section-header-wrap">
        <Row className="justify-content-between align-items-center g-3">
          <Col>
          <div className='backbtn'>
          <PageBackButton />
            <ResponsiveTitle className="title-text">
              Edit Staff
            </ResponsiveTitle>
          </div>
         
          </Col>

          <Col>
            <ButtonContainer className="d-flex justify-content-md-end">
              <div className="ms-auto ms-md-2">
                <NotificationIconContainer />
              </div>
            </ButtonContainer>
          </Col>
        </Row>
      </HeaderSection>

      <Formik
        enableReinitialize
        initialValues={{
          email: staffDetails?.email || '',
          password: staffDetails?.password || '',
          adminUsername: staffDetails?.adminUsername || '',
          firstName: staffDetails?.firstName || '',
          lastName: staffDetails?.lastName || '',
          parentFirstName: staffDetails?.parentFirstName || '',
          parentLastName: staffDetails?.parentLastName || '',
          role: ROLES.find(({ roleId }) => roleId === staffDetails?.adminRoleId)?.title || null,
          permission: staffDetails?.userPermission?.permission || {},
          group: staffDetails?.group || '',
          adminId: staffDetails?.parentId || '',
          countryCode: staffDetails?.countryCode || '',
          phoneCode: staffDetails?.phone?.split(' ')[0] || '',
          phone: staffDetails?.phone?.split(' ')[1] || '',
          isPhoneVerified: staffDetails?.isPhoneVerified || false,
          // Add original phone for comparison
          originalPhone: staffDetails?.phone || ''
        }}
        validationSchema={updateStaffSchema}
        onSubmit={(formValues) => {
          handleCreateSubmit(formValues)
        }}
      >
        {({
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          setFieldValue,
          setFieldTouched,
          dirty,
          isValid,
          errors,
          touched
        }) => (
          <StaffForm
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            errors={errors}
            touched={touched}
            isValid={isValid}
            dirty={dirty}
            staffDetails={staffDetails}
            isEdit
            originalPhone={getOriginalPhone()}
          />
        )}
      </Formik>
    </div>
  )
}

export default EditStaff
